import React, { useContext, useMemo, useEffect } from "react";
import { isEmpty } from "lodash";
import { Form } from "react-bootstrap";
import { useFormContext } from "react-hook-form";
import { useSelector } from "react-redux";

import { Tooltip } from "components";
import { safeParseFloat } from "helpers";
import { getFilters } from "store/filters/filters.reducer";
import { FilterColumn } from "types";

import NumericRangeInputErrorMessage from "./numericRangeInputErrorMessage";
import NumericRangeSection from "./numericRangeSection";
import FiltersContext from "../filtersContext";

import styles from "../filter.module.scss";

type FilterNumericRangeInputProps = {
	column: FilterColumn & {
		nameInputFrom: string;
		nameInputTo: string;
		formName: string;
		normalize: Function;
		normalizeOnBlur: Function;
		title: string;
		addon: "$";
	};
	className?: string;
};

const FilterNumericRangeInput = ({ column }: FilterNumericRangeInputProps) => {
	const { setIsApplyDisabled } = useContext(FiltersContext);
	const { watch, register } = useFormContext();
	const valueInputFrom = watch(column.nameInputFrom);
	const valueInputTo = watch(column.nameInputTo);
	const formValuesFromRedux = useSelector(getFilters(column.formName)) || {};
	const storedInputValueFrom =
		formValuesFromRedux[column?.nameInputFrom || ""];
	const storedInputValueTo = formValuesFromRedux[column?.nameInputTo || ""];

	const isDurationInvalid = useMemo(() => {
		let isInvalid = false;

		if (!isEmpty(storedInputValueTo) && !isEmpty(valueInputFrom)) {
			isInvalid =
				safeParseFloat(storedInputValueTo, "") <
				safeParseFloat(valueInputFrom, "");
		}

		if (!isEmpty(storedInputValueFrom) && !isEmpty(valueInputTo)) {
			isInvalid =
				safeParseFloat(valueInputTo, "") <
				safeParseFloat(storedInputValueFrom, "");
		}

		if (!isEmpty(valueInputFrom) && !isEmpty(valueInputTo)) {
			isInvalid =
				safeParseFloat(valueInputTo, "") <
				safeParseFloat(valueInputFrom, "");
		}
		return isInvalid;
	}, [
		valueInputFrom,
		valueInputTo,
		storedInputValueFrom,
		storedInputValueTo,
	]);

	useEffect(() => {
		setIsApplyDisabled?.(isDurationInvalid);
	}, [isDurationInvalid, setIsApplyDisabled]);

	return (
		<div className={styles.column}>
			<Tooltip
				trigger="click"
				position="bottom"
				interactive
				html={
					<div className={styles.agePickerContent}>
						<NumericRangeSection
							register={register}
							isInvalid={isDurationInvalid}
							section={{
								nameInputFrom: column.nameInputFrom,
								nameInputTo: column.nameInputTo,
								normalize: column.normalize,
								normalizeOnBlur: column.normalizeOnBlur,
								title: column.title,
								addon: column.addon,
							}}
						/>
						{isDurationInvalid && <NumericRangeInputErrorMessage />}
					</div>
				}
			>
				<Form.Control
					name={column.name}
					placeholder={column.placeholder}
					className={styles.input}
					readOnly
				/>
			</Tooltip>
		</div>
	);
};

export default FilterNumericRangeInput;
